import { render, staticRenderFns } from "./evolutionPivotClient.vue?vue&type=template&id=06e913b7&scoped=true"
import script from "./evolutionPivotClient.vue?vue&type=script&lang=js"
export * from "./evolutionPivotClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e913b7",
  null
  
)

export default component.exports